import React from "react";
import { Box, TextField, Button } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import Header from "../../../../../components/Header";
import { AssetFinanceUrl } from "../../../../../config";
import { executeAnyMutation } from "../../../../../data/DynamicServiceNew/jsondynamicservice";

const base_url = AssetFinanceUrl.uri;

const validationSchema = yup.object().shape({
  fullName: yup.string().required("Director name is required"),
  email: yup.string().email("Enter a valid email").nullable(),
});

// props.companyOwnerId is injected by the wrapper in DirectorsModal.jsx
const DirectorForm = (props) => {
  const swal = (options) =>
    Swal.fire({
      ...options,
      didOpen: () => {
        const el = document.querySelector(".swal2-container");
        if (el) el.style.zIndex = "99999";
        options?.didOpen?.();
      },
    });

  const initialValues = {
    fullName: props.data?.FullName || "",
    email: props.data?.Email || "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    if (!props.companyOwnerId) {
      swal({ icon: "error", title: "Missing company reference", text: "Could not determine which company this director belongs to." });
      setSubmitting(false);
      return;
    }
    try {
      const payload = {
        companyOwnerId: Number(props.companyOwnerId),
        fullName: values.fullName,
        email: values.email,
      };
      const response = await executeAnyMutation(
        props.isEditing ? "updateCollateralCompanyDirector" : "saveCollateralCompanyDirector",
        props.isEditing ? { ...payload, id: Number(props.data.Id) } : payload,
        "director",
        false,
        base_url,
      );
      if (response?.results) {
        props.onClose();
        props.onAction();
        swal({ icon: "success", title: "Success!", text: `Director ${props.isEditing ? "updated" : "added"} successfully.` });
      } else {
        swal({ icon: "error", title: "Error!", text: response?.error || "Could not save director." });
      }
    } catch {
      swal({ icon: "error", title: "Error!", text: "An error occurred while saving. Please try again." });
    }
    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Director" : "Add Director"}
        subtitle="Capture this company's director details"
      />
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize>
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="20px" gridTemplateColumns="repeat(4, minmax(0, 1fr))">
              <TextField fullWidth variant="filled" label="Director Name *" name="fullName" value={values.fullName} onChange={handleChange} onBlur={handleBlur} error={!!touched.fullName && !!errors.fullName} helperText={touched.fullName && errors.fullName} sx={{ gridColumn: "span 2" }} />
              <TextField fullWidth variant="filled" label="Email" name="email" value={values.email} onChange={handleChange} onBlur={handleBlur} error={!!touched.email && !!errors.email} helperText={touched.email && errors.email} sx={{ gridColumn: "span 2" }} />
            </Box>
            <Box display="flex" justifyContent="flex-end" mt="24px">
              <Button type="submit" color="secondary" variant="contained" disabled={isSubmitting}>
                {isSubmitting ? "Saving…" : props.isEditing ? "Update Director" : "Save Director"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default DirectorForm;